<template>
   <section class="page__title-area page__title-height page__title-overlay d-flex align-items-center"
            :style="{background:'url('+require( $route.path == '/contact' ? '../../assets/img/contact/contact.jpg' :
            $route.path == '/biz_haqimizda' ?  '../../assets/img/about/aboutt.jpg' :
             $route.path == '/aboutDuk' ?  '../../assets/img/about/abour.jpg' :
              $route.path == '/faq' ?  '../../assets/img/about/faq.jpg' :
              $route.path == '/raqamlashtirish' ?  '../../assets/img/raqam4.jpg' :
             '../../assets/img/raqam4.jpg')+')',backgroundPosition:'center',backgroundSize:'cover',backgroundRepeat:'no-repeat'}"
             >
      <div class="container">
         <div class="row">
            <div class="col-xxl-12">
               <div class="page__title-wrapper mt-110">
                  <h3 class="page__title">{{ $t(title) }}</h3>
                  <nav aria-label="breadcrumb">
                     <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                           <router-link to="/">{{ $t('actions.home') }}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                        {{ $t(subtitle) }}</li>
                     </ol>
                  </nav>
               </div>
            </div>
         </div>
      </div>
   </section>
</template>

<script>
import router from "../../router";

export default {
   name:'PageTitle',
  methods: {
    router() {
      return router
    }
  },
   props:{
      title:String,
      subtitle:String,
   }
};
</script>

